import { render, staticRenderFns } from "./StandardView.vue?vue&type=template&id=13af2cb3&scoped=true"
import script from "./StandardView.vue?vue&type=script&lang=js"
export * from "./StandardView.vue?vue&type=script&lang=js"
import style0 from "./StandardView.vue?vue&type=style&index=0&id=13af2cb3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13af2cb3",
  null
  
)

export default component.exports